import React, { useId } from "react";

interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  helpText?: string;
  required?: boolean;
  disabled?: boolean;
  type?: "text" | "email" | "tel" | "date";
  maxLength?: number;
  min?: string;
  max?: string;
}

const TextField: React.FC<TextFieldProps> = ({ label, value: rawValue, onChange, placeholder = "", error, helpText, required = false, disabled = false, type = "text", maxLength, min, max }) => {
  const value = rawValue ?? '';
  const id = useId();
  const labelSt: React.CSSProperties = { fontSize: "12px", fontWeight: 500, color: "var(--t2, #5A6178)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", lineHeight: "16px" };
  const inputSt: React.CSSProperties = { fontSize: "13px", fontFamily: "var(--font-primary, DM Sans, sans-serif)", color: disabled ? "var(--t3, #9CA3B8)" : "var(--t1, #1A1D2E)", backgroundColor: disabled ? "var(--hover, #F0F1F5)" : "var(--surface, #FFFFFF)", border: error ? "1px solid var(--red, #E5484D)" : "1px solid var(--card-border, #E2E5EC)", borderRadius: "8px", padding: "10px 14px", outline: "none", width: "100%", boxSizing: "border-box" as const, transition: "border-color 0.15s ease, box-shadow 0.15s ease", cursor: disabled ? "not-allowed" : "text" };
  const errSt: React.CSSProperties = { fontSize: "11px", fontWeight: 500, color: "var(--red, #E5484D)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", margin: 0 };
  const cntSt: React.CSSProperties = { fontSize: "11px", color: "var(--t3, #9CA3B8)", fontFamily: "var(--font-mono, DM Mono, monospace)", marginLeft: "auto" };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px", width: "100%" }}>
      <label htmlFor={id} style={labelSt}>
        {label}
        {required && <span style={{ color: "var(--accent, #D23A3B)", marginLeft: "2px" }}>*</span>}
      </label>
      <input id={id} type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} disabled={disabled} maxLength={maxLength} required={required} min={min} max={max} style={inputSt} onFocus={(e) => { if (!error) { e.currentTarget.style.borderColor = "var(--accent, #D23A3B)"; e.currentTarget.style.boxShadow = "0 0 0 3px var(--accent-soft, rgba(210, 58, 59, 0.1))"; } }} onBlur={(e) => { if (!error) { e.currentTarget.style.borderColor = "var(--card-border, #E2E5EC)"; e.currentTarget.style.boxShadow = "none"; } }} />
      {helpText && !error && <p style={{ fontSize: "11px", color: "var(--t3, #9CA3B8)", margin: 0 }}>{helpText}</p>}
      {(error || maxLength !== undefined) && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", minHeight: "16px" }}>
          {error ? <p style={errSt}>{error}</p> : <span />}
          {maxLength !== undefined && <span style={cntSt}>{value.length}/{maxLength}</span>}
        </div>
      )}
    </div>
  );
};

export default TextField;
